"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var _1 = require("./");
/**
 * *******************************
 * Constants and Types
 * *******************************
 */
exports.REBASE_DATA_TYPE = {
    value: 'value',
    change: 'change',
    changePercent: 'changePercent'
};
exports.REBASE_VALUE_METHOD = {
    mash: 'mash',
    absoluteDelta: 'absoluteDelta',
    triodos: 'triodos'
};
/**
 * *******************************
 * Functions
 * *******************************
 */
function calculateRebaseOnChangePercent(options) {
    var lastKeyValues = options.lastKeyValues, model = options.model, params = options.params, record = options.record, recordIndex = options.recordIndex, newRecord = options.newRecord, rebasedData = options.rebasedData;
    model.keyNames.forEach(function (keyName) {
        var keyChange = 1 + (params.divideChangePercentByOneHundred ? record[keyName] / 100 : record[keyName]);
        var newValue = rebasedData[recordIndex - 1][keyName] * keyChange;
        lastKeyValues[keyName] = keyChange;
        newRecord[keyName] = params.valueFormatter(newValue);
    });
}
function calculateRebaseOnChange(options) {
    var lastKeyValues = options.lastKeyValues, model = options.model, params = options.params, record = options.record, recordIndex = options.recordIndex, newRecord = options.newRecord, rebasedData = options.rebasedData;
    model.keyNames.forEach(function (keyName) {
        var keyChange = record[keyName];
        var newValue = rebasedData[recordIndex - 1][keyName] + keyChange;
        lastKeyValues[keyName] = keyChange;
        newRecord[keyName] = params.valueFormatter(newValue);
    });
}
function calculateRebaseOnValue(options) {
    var lastKeyValues = options.lastKeyValues, model = options.model, params = options.params, record = options.record, recordIndex = options.recordIndex, newRecord = options.newRecord, rebasedData = options.rebasedData;
    model.keyNames.forEach(function (keyName) {
        var newRebasedValue = determineRecordChange(lastKeyValues[keyName], record[keyName], rebasedData[recordIndex - 1][keyName]);
        lastKeyValues[keyName] = record[keyName];
        newRecord[keyName] = params.valueFormatter(newRebasedValue);
    });
    function determineRecordChange(previousValue, currentValue, previousInWorkingSet) {
        if (params.rebaseMethod === exports.REBASE_VALUE_METHOD.absoluteDelta) {
            return previousInWorkingSet + getChange(previousValue, currentValue);
        }
        else if (params.rebaseMethod === exports.REBASE_VALUE_METHOD.mash) {
            return getRebasedNextValue(previousValue, currentValue);
        }
        else if (params.rebaseMethod === exports.REBASE_VALUE_METHOD.triodos) {
            return getRebasedNextValueTriodos(previousValue, currentValue, previousInWorkingSet);
        }
    }
}
function maintainOriginalKey(params, record, newRecord) {
    if (params.maintainUnusedKeys) {
        newRecord = Object.assign({}, record, newRecord);
    }
    return newRecord;
}
function getChange(lastValue, newValue) {
    var change = Math.abs(lastValue - newValue);
    var direction = newValue >= lastValue;
    return direction ? change : -change;
}
// CHANGE ==> (current - previous) / previous * 100
// VALUE  ==> (change / 100 + 1) * previous
function getRebasedNextValue(lastValue, newValue) {
    var change = (newValue - lastValue) / lastValue * 100;
    var value = (change / 100 + 1) * lastValue;
    return value;
}
function getRebasedNextValueTriodos(previousValue, currentValue, previousWorkingValue) {
    return previousWorkingValue * (currentValue / previousValue);
}
function isUsingValueDataType(params) {
    return params.dataType === exports.REBASE_DATA_TYPE.value;
}
/**
 * Will return rebased performance data
 *
 * @export
 * @param {IRebaseParameters} params
 * @returns {any}
 */
function rebaseData(params) {
    if (!_1.isNullOrUndefined(params.allData) && !_1.isNullOrUndefined(params.rebaseFrom) && !_1.isNullOrUndefined(params.model)) {
        var model_1 = params.model;
        var rebasedData_1 = [];
        var copyAllData = _1.sortBy(JSON.parse(JSON.stringify(params.allData)), function (record) { return moment(record[model_1.dateName]); });
        if (_1.isNullOrUndefined(params.divideChangePercentByOneHundred)) {
            params.divideChangePercentByOneHundred = true;
        }
        if (_1.isNullOrEmpty(params.fromDate)) {
            params.fromDate = copyAllData[0][model_1.dateName];
        }
        if (_1.isNullOrEmpty(params.toDate)) {
            params.toDate = copyAllData[copyAllData.length - 1][model_1.dateName];
        }
        if (!params.valueFormatter) {
            params.valueFormatter = function (value) {
                return value;
            };
        }
        if (!params.dateFormatter) {
            params.dateFormatter = function (value) {
                return value;
            };
        }
        if (_1.isNullOrUndefined(params.maintainUnusedKeys)) {
            params.maintainUnusedKeys = true;
        }
        if (isUsingValueDataType(params)) {
            if (_1.isNullOrUndefined(params.rebaseMethod)) {
                // we default the rebaseMethod here. 
                params.rebaseMethod = 'absoluteDelta';
            }
        }
        if (moment(params.fromDate) < moment(params.toDate)) {
            var splicedData = copyAllData.filter(function (record) {
                var recordDate = record[model_1.dateName];
                return moment(recordDate).isBetween(moment(params.fromDate), moment(params.toDate), null, '[]');
            });
            var lastKeyValues_1 = {};
            splicedData.forEach(function (record, recordIndex) {
                var _a;
                var newRecord = (_a = {}, _a[model_1.dateName] = params.dateFormatter(record[model_1.dateName]), _a);
                if (Object.keys(lastKeyValues_1).length > 0) {
                    if (model_1.keyNames && model_1.keyNames.length > 0) {
                        var calcParams = { rebasedData: rebasedData_1, lastKeyValues: lastKeyValues_1, record: record, recordIndex: recordIndex, newRecord: newRecord, params: params, model: model_1 };
                        if (isUsingValueDataType(params)) {
                            calculateRebaseOnValue(calcParams);
                        }
                        else if (params.dataType === exports.REBASE_DATA_TYPE.change) {
                            calculateRebaseOnChange(calcParams);
                        }
                        else if (params.dataType === exports.REBASE_DATA_TYPE.changePercent) {
                            calculateRebaseOnChangePercent(calcParams);
                        }
                    }
                    newRecord = maintainOriginalKey(params, record, newRecord);
                }
                else {
                    // rebase from using passed parameter
                    if (model_1.keyNames && model_1.keyNames.length > 0) {
                        model_1.keyNames.forEach(function (keyName) {
                            lastKeyValues_1[keyName] = record[keyName];
                            newRecord[keyName] = params.valueFormatter(params.rebaseFrom);
                        });
                    }
                    newRecord = maintainOriginalKey(params, record, newRecord);
                }
                rebasedData_1.push(newRecord);
            });
        }
        return rebasedData_1;
    }
    else {
        return [];
    }
}
exports.rebaseData = rebaseData;
//# sourceMappingURL=rebase.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/rebase.js
// module id = 1453
// module chunks = 1